import { dispatchEvent } from 'redux-ruleset'
import { Cart } from 'hooks/account/types'

export const cartPageView = (cart: Cart) =>
  dispatchEvent({
    type: 'cart/PAGE_VIEW' as const,
    meta: {},
    payload: { cart: cart }
  })
export const beginCheckout = (cart: Cart) =>
  dispatchEvent({
    type: 'cart/BEGIN_CHECKOUT' as const,
    meta: {},
    payload: { cart: cart }
  })

export const showChannelRestrictedModal = (
  sku: string,
  title: string,
  loggedIn: boolean
) =>
  dispatchEvent({
    type: 'cart/SHOW_CHANNEL_RESTRICTED_MODAL' as const,
    meta: { sku, title, loggedIn }
  })

export const removeRestrictedItemsClick = (sku: string, title: string) =>
  dispatchEvent({
    type: 'cart/REMOVE_RESTRICTED_ITEMS_CLICK' as const,
    meta: { sku, title }
  })

export const contactSupportClick = () =>
  dispatchEvent({
    type: 'cart/CONTACT_SUPPORT_CLICK' as const
  })

export const switchChannelByChannelModal = () =>
  dispatchEvent({
    type: 'cart/SWITCH_CHANNEL_BY_CHANNEL_MODAL' as const
  })

export type Event =
  | ReturnType<typeof cartPageView>
  | ReturnType<typeof beginCheckout>
  | ReturnType<typeof showChannelRestrictedModal>
  | ReturnType<typeof removeRestrictedItemsClick>
  | ReturnType<typeof contactSupportClick>
  | ReturnType<typeof switchChannelByChannelModal>

declare global {
  interface RulesetDispatchEvents {
    'cart/View': Event
  }
}
